<template>
  <div class="player">
    <div class="row">
      <div class="col-md-8 col-12">
        <div class="player-controls">
          <div class="divleft">
            <div id="preview" class="preview">
              <button title="Trước" class="player-control" @click.prevent="preview">
                <span class="SkipBackIcon" />
              </button>
            </div>
            <div v-if="playing" id="stop">
              <button title="Stop" class="player-control" @click.prevent="stop">
                <span class="StopIcon" />
              </button>
            </div>
            <div v-else id="play">
              <button :title="(playing) ? 'Pause' : 'Play'" class="player-control" @click.prevent="play">
                <span class="Play" />
              </button>
            </div>
            <div id="next" class="next">
              <button title="Tiếp theo" class="player-control" @click.prevent="next">
                <span class="SkipForwardIcon" />
              </button>
            </div>
          </div>
          <div class="player-time-current">{{ this.currentSecondsConverted }} </div>
          <div id="seek">
            <div class="player-timeline">
              <div :style="progressStyle" class="player-progress" />
              <div class="player-seeker" title="Seek" @click="seek" />
            </div>
          </div>
          <div class="player-time"> {{ this.durationSecondsConverted }} </div>
          <div id="mute">
            <button class="player-control" title="Mute" @click.prevent="mute">
              <span :class="volume == 0 ? 'SpeakerSlash' : 'SpeakerHigh'" />
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-4 col-12">
        <div class="player-info">
          <h3>{{ (itemPlay.programName) ? itemPlay.programName : "Đài tiếng nói Việt Nam" }}</h3>
          <span v-if="channel_name">{{ channel_name }}</span>
          <span @click="onDownload(itemPlay)">
            <i v-if="itemPlay.programName" class="btnDownload" /></span>
        </div>
      </div>
    </div>
    <audio :loop="looping" ref="audio" autoplay="true" :src="itemPlay.urlPath" v-on:timeupdate="update"
      v-on:loadeddata="load" v-on:pause="playing = false" v-on:play="playing = true" preload="auto"
      style="display: none;" />
  </div>
</template>
<script>
function convertTimeHHMMSS(val) {
  let hhmmss = new Date(val * 1000).toISOString().substr(11, 8);
  return hhmmss.indexOf("00:") === 0 ? hhmmss.substr(3) : hhmmss;
}
export default {
  props: {
    playlist: Array,
    channel_name: {
      type: String,
      default: '',
    },
    titleId: String,
    stopPlay: Boolean,
    itemPlay: {
      type: Object,
      default: () => { },
    },
    loop: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentSeconds: 0,
    durationSeconds: 0,
    loaded: false,
    looping: false,
    playing: false,
    previousVolume: 35,
    showVolume: false,
    volume: 100
  }),
  computed: {
    currentSecondsConverted() {
      return convertTimeHHMMSS(this.currentSeconds);
    },
    durationSecondsConverted() {
      return convertTimeHHMMSS(this.durationSeconds);
    },
    muted() {
      return this.volume / 100 === 0;
    },
    percentComplete() {
      return parseInt(this.currentSeconds / this.durationSeconds * 100);
    },
    progressStyle() {
      return { width: `${this.percentComplete}%` };
    },
    volumeTitle() {
      return `Volume (${this.volume}%)`;
    },
  },
  watch: {
    playing(value) {

      // if (value) { return this.$refs.audio.play(); }
      // this.$refs.audio.pause();
      // this.$refs.audio.currentTime = 0;
    },
    volume(value) {
      this.$refs.audio.volume = this.volume / 100;
    },
  },

  methods: {
    load() {

      if (this.$refs.audio.readyState >= 2) {
        this.loaded = true;
        this.durationSeconds = parseInt(this.$refs.audio.duration);
        return this.playing = this.autoPlay;
      }
      throw new Error('Failed to load sound file.');
    },
    mute() {
      if (this.muted) {
        return this.volume = this.previousVolume;
      }

      this.previousVolume = this.volume;
      this.volume = 0;
    },
    seek(e) {
      if (!this.loaded) return;
      const bounds = e.target.getBoundingClientRect();
      const seekPos = (e.clientX - bounds.left) / bounds.width;
      this.$refs.audio.currentTime = parseInt(this.$refs.audio.duration * seekPos);
    },
    play() {
      this.playing = true
      this.$emit('updateAudio', 'play', this.titleId)

      this.$refs.audio.play();
    },
    stop() {
      this.playing = false;
      this.$refs.audio.pause();
      this.$emit('updateAudio', 'play', this.titleId)
      //this.$refs.audio.currentTime = 0;
    },
    next() {
      if (this.titleId) {
        this.$emit('updateAudio', 'next', this.titleId)
      }
    },
    preview() {
      if (this.position > 1) {
        this.$emit('updateAudio', 'preview', this.position)
      }
    },
    update(e) {

      this.currentSeconds = parseInt(this.$refs.audio.currentTime);
      if (this.stopPlay) {
        this.playing = false;
        this.$refs.audio.pause();
      }
      // if (parseInt(this.$refs.audio.duration) == this.currentSeconds) {
      //   this.$emit('updateAudio', 'next', this.titleId)
      // }
    },
    async onDownload(item) {

      const ext = item.urlPath.split('.').pop()
      const name = `${item.programName}.${ext}`;
      const url = item.urlPath;
      const data = await fetch(url);
      const blob = await data.blob();
      const objectUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.setAttribute('href', objectUrl);
      link.setAttribute('download', name);
      link.style.display = 'none';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
  },

}
</script>
<style lang="scss">
.player-wrapper {
  align-items: center;
  display: flex;
  width: 100%;
}

.player {
  color: #3333;
  position: relative;
  width: 100%;
  display: block;
  align-items: center;
  align-content: center;

  .row {
    margin: 0 -0.5rem;

    .col-12 {
      padding: 0 0.5rem;
      margin: auto;
    }
  }

  .player-controls {
    align-items: center;
    display: flex;

    .divleft {
      display: flex;
      flex-direction: row;
    }

    .player-time-current {
      font-weight: 700;
      color: #086BB5
    }

    .player-time {
      color: #84818A;
    }

    #seek {
      align-content: center;
      width: calc(100% - 200px);
      display: flex;
      align-items: center;
      padding: 0 0.5rem;

      .player-timeline {
        background-color: #E8E8E8;
        height: 6px;
        width: 100%;
        border-radius: 10px;
        position: relative;

        .player-progress,
        .player-seeker {
          bottom: 0;
          height: 100%;
          left: 0;
          position: absolute;
          top: 0;
        }

        .player-progress {
          background-color: #086BB5;
          border-radius: 10px;
          z-index: 1;
        }

        .player-seeker {
          cursor: pointer;
          width: 100%;
          z-index: 2;
        }
      }
    }
  }

  .player-info {
    position: relative;

    h3 {
      font-size: 16px;
      margin: 0 0 0.2rem 0;
    }

    span {
      font-size: 14px;
      color: #7b7b7b;
    }

    .btnDownload {
      position: absolute;
      right: 0;
      top: 0;
      cursor: pointer;
    }
  }

}

.player-control {
  background-color: white;
  border: none;
  color: #333;
  cursor: pointer;
  display: flex;
  line-height: 0;
  margin: 0;
  padding: 0.5em;
  text-decoration: none;

}

.player-time {
  display: flex;
  justify-content: space-between;
  max-width: 12.8125rem;

  .player-time-current {
    font-weight: 700;
    padding: 0 0.3125rem;
  }

  .player-title {
    display: flex;
    // mask-image: linear-gradient(90deg,
    //     hsla(0, 0, 0, 0) 0%,
    //     hsla(0, 0, 0, 1) 25%,
    //     hsla(0, 0, 0, 1) 75%,
    //     hsla(0, 0, 0, 0) 100%);
    flex-grow: 1;
    max-width: 6rem;
    overflow: hidden;

    p {
      animation: slide-x 10s linear infinite;
      white-space: nowrap;

      @keyframes slide-x {
        0% {
          transform: translateX(0);
        }

        100% {
          transform: translateX(-100%);
        }
      }
    }
  }
}

.player-volume {
  display: inline-block;
  height: 1.1rem;
  margin: 0 0 0 0.625rem;
  width: 7.925rem;
}
</style>
